module.exports = "<canvas data-no-op-canvas></canvas>\n<p data-no-op-msg><%=message%><p>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/clappr/src/playbacks/no_op/public/error.html
// module id = 274
// module chunks = 0